import './ReferenceLines.css'
import { useSettings } from 'Settings'
import ReferenceLine from './ReferenceLine'
import ValueTransform from 'ValueTransform'

const ReferenceLines = ({ rect }) => {
	const [settings] = useSettings()

	const acc = settings['supervisory level']['v_lvl_acc'].value
	const v_cs_acc = settings['cold-start accuracy']['v_cs_acc'].value
	const v_bat_max_hi = ValueTransform(settings['supervisory level']['v_bat_max_hi'].value, acc)
	const v_bat_min_hi_dis = ValueTransform(settings['supervisory level']['v_bat_min_hi_dis'].value, acc)
	const v_bat_min_hi_con = ValueTransform(settings['supervisory level']['v_bat_min_hi_con'].value, acc)
	const v_bat_max_lo = ValueTransform(settings['supervisory level']['v_bat_max_lo'].value, acc)
	const v_bat_min_lo = ValueTransform(settings['supervisory level']['v_bat_min_lo'].value, acc)
	const v_apl_max_lo = ValueTransform(settings['supervisory level']['v_apl_max_lo'].value, acc)
	const v_apl_max_hi = ValueTransform(settings['supervisory level']['v_apl_max_hi'].value, acc)
	const v_ulp_ldo = parseFloat(settings['ldo levels']['v_ulp_ldo'].value)
	const v_aux_ldo = parseFloat(settings['ldo levels']['v_aux_ldo'].value)

	let v_cs_hi = 0
	let v_cs_lo = 0

	if (v_cs_acc === 'MAX') {
		v_cs_hi = 1.369
		v_cs_lo = 1.169
	} else {
		v_cs_hi = 1.3
		v_cs_lo = 1.1
	}

	return (
		<>
			<ReferenceLine
				rect={rect}
				className='graph-red'
				strokeWidth="1"
				y={v_bat_max_hi}
				name="v_bat_max_hi"
			/>
			<ReferenceLine
				rect={rect}
				className='graph-red'
				strokeWidth="1"
				y={v_bat_max_lo}
				name="v_bat_max_lo"
				strokeDasharray="5 5"
				right={true}
				bottom={true}
			/>
			<ReferenceLine
				rect={rect}
				className='graph-yellow'
				strokeWidth="1"
				y={v_apl_max_hi}
				name="v_apl_max_hi"
			/>
			<ReferenceLine
				rect={rect}
				className='graph-yellow'
				strokeWidth="1"
				strokeDasharray="5 5"
				y={v_apl_max_lo}
				name="v_apl_max_lo"
				right={true}
				bottom={true}
			/>
			<ReferenceLine
				rect={rect}
				className='graph-green'
				strokeWidth="1"
				y={v_bat_min_hi_dis}
				name="v_bat_min_hi_dis"
			/>
			<ReferenceLine
				rect={rect}
				className='graph-green'
				strokeWidth="1"
				y={v_bat_min_hi_con}
				name="v_bat_min_hi_con"
				right={true}
				bottom={true}
			/>
			<ReferenceLine
				rect={rect}
				className='graph-green'
				strokeWidth="1"
				strokeDasharray="5 5"
				y={v_bat_min_lo}
				name="v_bat_min_lo"
			/>
			<ReferenceLine
				rect={rect}
				className='graph-purple'
				strokeWidth="1"
				y={v_ulp_ldo}
				name="v_ulp_ldo"
				right={true}
				bottom={true}
			/>
			<ReferenceLine
				rect={rect}
				className='graph-purple'
				strokeWidth="1"
				strokeDasharray="5 5"
				y={v_aux_ldo}
				name="v_aux_ldo"
				right={true}
				bottom={true}
			/>
			<ReferenceLine
				rect={rect}
				className='graph-gray'
				strokeWidth="1"
				y={v_cs_hi}
				name="v_cs_hi"
			/>
			<ReferenceLine
				rect={rect}
				className='graph-gray'
				strokeWidth="1"
				strokeDasharray="5 5"
				y={v_cs_lo}
				name="v_cs_lo"
				right={true}
				bottom={true}
			/>
		</>
	)
}


export default ReferenceLines
